export default "__VITE_ASSET__75605825__"